import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { indexOf, values } from "lodash";
import Description from "./components/description";
import StageName from "./components/stage-name";
import Header from "./components/header";
import Result from "./components/result";
import Prompt from "./components/prompt";
import Dialectic from "./models/dialectic";
import EntryForm from "./components/entry-form";
import "./dark.min.css";

import { DIALECTIC, RESULT } from "./constants";

const HegelWrapper = styled.div`
	max-width: 600px;
`;

const getNextStage = (currentStage) =>
	values(DIALECTIC)[indexOf(values(DIALECTIC), currentStage) + 1] || RESULT;

const Hegel = () => {
	const [dialectic, setDialectic] = useState(new Dialectic());
	const [stage, setStage] = useState(DIALECTIC.CONCEPT);
	const [viewDescription, setViewDesciption] = useState(true);
	const handleChange = (e) => {
		const { id, value } = e.target;
		setDialectic({ ...dialectic, [id]: value });
	};
	const handleClick = (e) => {
		const { id } = e.target;
		if (id === `button-${DIALECTIC.CONCEPT}`)
			return setStage(DIALECTIC.NEGATION);
		if (id === `button-${DIALECTIC.NEGATION}`)
			return setStage(DIALECTIC.SYNTHESIS);
		if (id === `button-${DIALECTIC.SYNTHESIS}`) return setStage(RESULT);
	};
	const handleKeypress = (e) => {
		if (e.key === "Enter") {
			const { id } = e.target;
			const nextStage = getNextStage(id);
			setStage(nextStage);
		}
	};

	const clear = () => {
		setDialectic(new Dialectic());
		return setStage(DIALECTIC.CONCEPT);
	};

	return (
		<HegelWrapper>
			<Header />
			<Description
				viewDescription={viewDescription}
				setViewDesciption={setViewDesciption}
			/>
			{!viewDescription && (
				<div>
					<StageName stage={stage} />
					<Prompt dialectic={dialectic} stage={stage} />
					{!viewDescription &&
						Object.keys(dialectic).reduce(
							(selected, item) =>
								stage === item ? (
									<EntryForm
										dialectic={dialectic}
										handleChange={handleChange}
										handleKeypress={handleKeypress}
										item={item}
										handleClick={handleClick}
										clear={clear}
									/>
								) : (
									selected
								),
							null
						)}
				</div>
			)}

			<Result
				handleClick={handleClick}
				handleChange={handleChange}
				dialectic={dialectic}
				clear={clear}
				setViewDesciption={setViewDesciption}
				stage={stage}
			/>
		</HegelWrapper>
	);
};
let App = document.getElementById("app");
ReactDOM.render(<Hegel />, App);
